import { INSTANCE_PERMISSIONS } from '@lumapps/instance/constants';
import { isUserAllowed } from '@lumapps/permissions';

export const isAdminSettingsAllowed = isUserAllowed(INSTANCE_PERMISSIONS.INSTANCE_EDIT);
